import errorMap from "@gap/backend/util/validations/validation-error-map"
import { z } from "zod"
import { CompareSchemas } from "@gap/utils/utils"
import { UserOrgEntityType } from "@gap/backend/database/entities/UserOrgEntity"
import { UserOrgPermissionEnumsSchema } from "./UserOrgPermissionEnum"
import validationConstants from "@gap/utils/validation/validation-constants"

const UserOrgEntityDtoSchema = z.object({
   userId: z.string({ errorMap }),
   orgId: z.string({ errorMap }),
   deactivatedOn: z.string({ errorMap }).optional(),
   deactivatedBy: z.string({ errorMap }).optional(),
   roleId: z.string({ errorMap }),
   createdAt: z.string({ errorMap }),
   createdBy: z.string({ errorMap }),
   lastUpdatedAt: z.string({ errorMap }),
   lastUpdatedBy: z.string({ errorMap }), 
   inviteSentOn: z.string({ errorMap }).optional(),
   chatTokenMonthlyLimit: z
      .number({ errorMap })
      .int()
      .min(validationConstants.userOrgEntity.minChatTokenMonthlyLimit)
      .max(validationConstants.userOrgEntity.maxChatTokenMonthlyLimit)
      .optional(),
   permissions: z.array(UserOrgPermissionEnumsSchema).optional()
})

// Ensure schema is equal to entity. Note, electrodb's EntityItem doesnt have support for optional types, but atleast we can check for variables
0 as CompareSchemas<z.output<typeof UserOrgEntityDtoSchema>, UserOrgEntityType>

export default UserOrgEntityDtoSchema